<template>
      <b-row class="mt-3 justify-content-center">
        <b-col md="8">
           <div class="alert alert-success" v-if="message">Informamos que a sua inscrição foi realizada com sucesso! Obrigado</div>
           <b-card v-if="!working" title="Inscrições" class="grey_card">
            <p>{{ activity.familymember.data.name }}</p>
            <div v-if="!activity">Não tem incrições abertas</div>
            <div  >
              <h5>Inscrito em: {{activity_name}}</h5>

              <b-row>
                <b-col md="6">
                  Preferências por ordem:
                  <b-list-group>
                    <b-list-group-item
                      v-for="(item) in activity.preferences"
                      :key="item.id"
                    > {{ item.name }} 

                    </b-list-group-item>
                  </b-list-group>
                </b-col>                
              </b-row>
              <p></p>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Respondi às seguintes perguntas:">                           
                  </b-form-group>
                </b-col> 
              </b-row>
              
              <dl class="row">
                <dt class="col-sm-4 text-md-right">Sabe nadar?</dt>
                <dd class="col-sm-7" v-if="registration.can_swim == 1">Sim</dd>
                <dd class="col-sm-7" v-else>Não</dd>

                  <dt class="col-sm-4 text-md-right">Toma medicação?</dt>
                  <dd class="col-sm-7" v-if="registration.has_medication == 1">Sim
                    <b-form-textarea plaintext :value="registration.medication"></b-form-textarea></dd>
                  <dd class="col-sm-7" v-else>Não</dd>

                  <dt class="col-sm-4 text-md-right">Tem alergias?</dt>
                  <dd class="col-sm-7" v-if="registration.is_alergic == 1">Sim
                  <b-form-textarea plaintext :value="registration.alergies"></b-form-textarea></dd>
                  <dd class="col-sm-7" v-else>Não</dd>
              </dl>
              <b-btn :to="{name:'Base'}" variant="primary">Voltar</b-btn>
            </div>
          </b-card>

        </b-col>
      </b-row>
</template>


<script>
export default {
  name: "LoginForm",
  props: ['message'],
  data() {
    return {
      working: true,
      family: null
    };
  },
  methods: {
  },
  created() {
    let id = this.$route.params.personId;
    let activityId = this.$route.params.activityId;

    // this.axios.get("front/familymember/" + id).then((response) => {
    //   this.person = response.data.data;
    // });
    this.axios.get('front/registration/'+id+'/'+activityId).then(response => {
        this.activity = response.data.data
        this.registration = response.data.meta.registration
        this.working = false
    });

    this.axios.get("front/registrations/" + id + '/' + activityId).then((response) => {
      this.activity_name = response.data.data.name;
     // this.working = false
    });
  }
};
</script>